import { render, staticRenderFns } from "./NewTextract.vue?vue&type=template&id=d05cc5c6&scoped=true&"
import script from "./NewTextract.vue?vue&type=script&lang=js&"
export * from "./NewTextract.vue?vue&type=script&lang=js&"
import style0 from "./NewTextract.vue?vue&type=style&index=0&id=d05cc5c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05cc5c6",
  null
  
)

export default component.exports